import { IProduct } from "../interfaces/product.interface";

export class Product implements IProduct {
  productName: string;

  constructor(product: IProduct) {
    Object.keys(product).map(key => this[key] = product[key]);
}
}